import TabsToggle from './tabsToggle';

export default TabsToggle;
